<template>
    <div>
        <configs-content :loading="!loaded">
            <h2 class="flex items-center text-3xl mb-4">
                <nio-icon class="mr-2" name="regular/single-neutral-id-card-3" />
                {{ $t('configs.rightPanel.profile.subtitles.profile') }}
            </h2>

            <user-info v-model="user" />

            <error-message class="mt-8" />
        </configs-content>

        <configs-footer>
            <nio-button
                color="blue"
                :loading="saving"
                @click="saveConfigs"
            >
                {{ $t('global.general.save') }}
            </nio-button>
        </configs-footer>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import cloneDeep from 'lodash/cloneDeep.js';
    import assign from 'lodash/assign.js';
    import ConfigsContent from '@/components/ConfigsContent.vue';
    import ConfigsFooter from '@/components/ConfigsFooter.vue';
    import UserInfo from '@/components/UserInfo.vue';

    export default {
        components: {
            ConfigsContent,
            ConfigsFooter,
            UserInfo,
        },

        data() {
            return {
                saving: false,
                loaded: false,
                user: {
                    id: null,
                    first_name: '',
                    last_name: '',
                    email: '',
                    locale: '',
                    timezone: '',
                    password: '',
                    password_confirmation: '',
                },
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),
        },

        watch: {
            authUser(newValue) {
                this.mergeWithoutAdding(this.user, newValue);

                this.$nextTick(() => {
                    this.loaded = true;
                });
            },
        },

        methods: {
            ...mapActions([
                'setAuthUser',
            ]),

            ...mapActions('setting', [
                'updateUser',
            ]),

            async saveConfigs() {
                this.saving = true;

                try {
                    const user = await this.updateUser(this.user);

                    const newAuthUser = assign(cloneDeep(this.authUser), user);
                    this.setAuthUser(newAuthUser);

                    this.clearPassword();

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('configs.rightPanel.profile.messages.updateSuccessful'),
                    });
                } catch ({ response }) {
                    this.$notify.show({
                        type: 'error',
                        message: this.$t('configs.rightPanel.profile.errors.update'),
                    });
                }

                this.saving = false;
            },

            clearPassword() {
                this.user.password = '';
                this.user.password_confirmation = '';
            },
        },
    };
</script>
